<template>
  <div class="e-fakture">
    <img
      class="path-4"
      src="/otplanding/path-6@2x.png"
      alt="Path"
    />
    <div class="anastasia-dan-ux-b-6 inter-medium-link-water-16px">izlaznim i ulaznim e-fakturama</div>
  </div>
</template>

<script>
export default {
  name: "EFakture",
};
</script>

<style>
.e-fakture,
.e-fakture-1 {
  height: 24px;
  margin-right: -17px;
  min-width: 324px;
  position: relative;
}

.path-4,
.path-5 {
  height: 9px;
  left: 0;
  position: absolute;
  top: 8px;
  width: 12px;
}

.anastasia-dan-ux-b-6,
.anastasia-dan-ux-b-7 {
  left: 21px;
  letter-spacing: -0.25px;
  line-height: 24px;
  position: absolute;
  top: 0;
  white-space: nowrap;
  width: 301px;
}
</style>
